'use client'
import type { AssistantMessage, AssistantAction } from './types'

export default function AssistantMessage({ msg, onActionClick }: { msg: AssistantMessage; onActionClick?: (a: AssistantAction) => void }) {
  const isUser = msg.role === 'user'
  return (
    <div style={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', marginBottom: 8 }}>
      <div
        style={{
          maxWidth: '80%',
          padding: '10px 14px',
          borderRadius: 12,
          background: isUser ? '#0ea5e9' : '#111827',
          color: '#ffffff',
          fontSize: 14,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      >
        {msg.content}
        {msg.actions && msg.actions.length > 0 && (
          <div style={{ marginTop: 8, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {msg.actions.map((a, i) => {
              const label =
                a.type === 'generate_resume' ? 'Generate Resume' : a.type === 'optimize_resume' ? 'Optimize Now' : 'View ATS Analysis'
              return (
                <button
                  key={i}
                  onClick={() => onActionClick && onActionClick(a)}
                  style={{
                    border: '1px solid #374151',
                    background: '#1f2937',
                    color: '#ffffff',
                    borderRadius: 8,
                    padding: '6px 10px',
                    fontSize: 13,
                    cursor: 'pointer'
                  }}
                >
                  {label}
                </button>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
